import styled, { css } from "styled-components";

export const Main = styled.main`
    max-width: 900px;
    margin: 0 auto;
    padding: 20px
`;